import appConfig from '@/config/appConfig.typed';

export const PUSH_NOTIFICATION_CONFIG = {
    get VAPID_PUBLIC_KEY() {
        return appConfig.getVapidPublicKey();
    },
    get FIREBASE_CONFIG() {
        return appConfig.getFirebaseConfig();
    },
};

export default PUSH_NOTIFICATION_CONFIG;
